import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DisplayListBoDtoNBK } from 'src/app/api/nbk';
import { getDisplayName, SelectableCookingMode } from 'src/app/core/utils';
import { NgSelectComponent, NgOptionTemplateDirective, NgLabelTemplateDirective } from '@ng-select/ng-select';
import { ControlErrorsComponent } from '../../control-errors/control-errors.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-display-selection-modal',
    templateUrl: './display-selection-modal.component.html',
    styleUrls: ['./display-selection-modal.component.scss'],
    imports: [ReactiveFormsModule, NgSelectComponent, NgOptionTemplateDirective, 
      NgLabelTemplateDirective, ControlErrorsComponent, TranslatePipe
    ]
})
export class DisplaySelectionModal implements OnInit {
  @Input() displays: DisplayListBoDtoNBK[] = [];
  @Input() currentDisplayIds: number[] = [];
  @Input() cookingMode: SelectableCookingMode[];

  cookingModeDisplay: DisplayListBoDtoNBK[] = [];

  @Output() 
  displaySelected: EventEmitter<DisplayListBoDtoNBK> = new EventEmitter();

  selectDisplayFormGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ts: TranslateService,
    public activeModal: NgbActiveModal
  ) {
    this.selectDisplayFormGroup = this.fb.group({
      cookingMode: [null],
      display: [null,[Validators.required]],
    });
  }

  ngOnInit() {
    if (this.cookingMode) {
      this.selectDisplayFormGroup.get('cookingMode')?.setValidators([Validators.required]);
      this.selectDisplayFormGroup.get('display')?.disable();
    } else {
      this.cookingModeDisplay = this.displays;
    }
  }

  onCookingModeChange(event: SelectableCookingMode) {
    this.selectDisplayFormGroup.get('display')?.enable();
    this.selectDisplayFormGroup.get('display')?.setValue(undefined);
    this.cookingModeDisplay = this.displays.filter( d => d.cookingMode === event.id)
                              .map( e => {
                                return {
                                  disabled: this.currentDisplayIds.includes(e.id!),
                                  ...e
                                };
                              });
  }

  isCurrentDeviceDisplay(item: DisplayListBoDtoNBK) {
    return this.currentDisplayIds.includes(item.id!);
  }

  getDisplayName( display: DisplayListBoDtoNBK ) {
    return getDisplayName(display.constructor!, display.name!, this.ts);
  }

  onConfirm() {
    if (this.selectDisplayFormGroup.invalid) {
      return;
    }

    const display = this.selectDisplayFormGroup.get('display')?.value;
    this.displaySelected.emit(display);

    this.activeModal.close();
  }

}
